import { GripVertical } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export interface DagColumnHeaderLabelProps {
  displayName: string
  isRequiredInput?: boolean
  tooltipText?: string
  // Movable columns show a drag grip on header hover (CSS in ag-grid-theme.css)
  isReorderable?: boolean
}

export function DagColumnHeaderLabel({
  displayName,
  isRequiredInput,
  tooltipText,
  isReorderable,
}: DagColumnHeaderLabelProps) {
  return (
    <TooltipProvider>
      <span className="inline-flex min-w-0 max-w-full items-center gap-1">
        {isReorderable && (
          <GripVertical
            aria-hidden
            className="dag-header-grip h-3.5 w-3.5 shrink-0 text-muted-foreground"
          />
        )}
        {tooltipText ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="cursor-help truncate">{displayName}</span>
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <p className="max-w-xs text-sm">{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        ) : (
          <span className="truncate">{displayName}</span>
        )}
        {isRequiredInput && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span
                className="shrink-0 cursor-help text-red-600"
                aria-label="input - required"
              >
                *
              </span>
            </TooltipTrigger>
            <TooltipContent side="bottom">input - required</TooltipContent>
          </Tooltip>
        )}
      </span>
    </TooltipProvider>
  )
}
